(function(){
  var m=window.location.pathname.match(/\/products\/([^?\/]+)/);
  if(!m)return;
  var handle=m[1];
  if(handle.indexOf('personaliza-')===0)return;
  if(handle.indexOf('por-mayor')!==-1){applyPorMayor();return;}
  fetch('/collections/portafolio-clientes-2026/products.json?limit=250').then(function(r){return r.json();}).then(function(d){var products=(d&&d.products)?d.products:[];var inPortafolio=false;for(var i=0;i<products.length;i++){if(products[i].handle===handle){inPortafolio=true;break;}}if(!inPortafolio)return;applyPortafolio();});
  function applyPorMayor(){
    function run(){
      if(!document.getElementById('pm-price-hide')){
        var ph=document.createElement('style');
        ph.id='pm-price-hide';
        ph.textContent=
          'span[id^="ProductPrice-"],#js-sticky-price,.product-single__price,.product-single__meta-price,'+
          '.price,.price-wrapper,.price__regular,.price__sale,[data-product-price],.product__price,'+
          '.price-item--regular,.price-item--sale,.product-price,.product__price-wrapper,'+
          '.price-item,.js-price,.product-meta__price,.product__price-badge'+
          '{display:none!important;}'+
          '#pm-unit-price{display:block!important;}';
        document.head.appendChild(ph);
      }
      var pf=document.querySelector('form.product-form');
      if(!pf||document.getElementById('allbags-pm-wrap'))return;
      var qi=document.querySelector('form.product-form input[name="quantity"]');
      var qp=null;
      if(qi){
        qp=qi.closest('[class*="quantity"],[class*="qty-wrap"],[class*="qty_wrap"],[class*="stepper"],[class*="counter"]');
        if(!qp){var p=qi.parentElement;if(p&&p.children.length<=6)qp=p;}
      }
      // Find native variant selector - we'll hide it always and use custom buttons instead
      var vs=pf.querySelector('.selector-wrapper.js')||pf.querySelector('.selector-wrapper')||pf.querySelector('[class*="selector-wrapper"]');
      if(!vs){var _r0=pf.querySelector('input[type="radio"]');if(_r0){for(var _p=_r0.parentElement;_p&&_p!==pf;_p=_p.parentElement){if(_p.querySelectorAll('input[type="radio"]').length>=2){vs=_p;break;}}}}
      console.log('[allbags-pm v8.4] vs=',vs?vs.className:'NULL','radios=',pf.querySelectorAll('input[type="radio"]').length);
      var sa=pf.querySelector('.product-form__quantity-submit');
      // \u00C1rea de impresi\u00F3n seg\u00FAn producto
      var areaDeImpresion=
        handle.indexOf('-21')!==-1?'7 x 7 cm':
        handle.indexOf('-32')!==-1?'14 x 14 cm':
        handle.indexOf('-41')!==-1?'18 x 18 cm':
        handle.indexOf('-45')!==-1?'22 x 22 cm':
        'Consultar con ventas';
      var wrap=document.createElement('div');
      wrap.id='allbags-pm-wrap';
      wrap.innerHTML=
        '<p style="font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:#111;margin:0 0 14px;">?Necesitas impresi\u00F3n personalizada?</p>'+
        '<div style="display:flex;gap:10px;margin-bottom:16px;">'+
          '<button type="button" id="pm-btn-sin" style="flex:1;padding:12px 8px;border:2px solid #ddd;background:#fff;cursor:pointer;border-radius:4px;font-size:13px;font-weight:600;color:#555;">Sin impresi\u00F3n</button>'+
          '<button type="button" id="pm-btn-con" style="flex:1;padding:12px 8px;border:2px solid #ddd;background:#fff;cursor:pointer;border-radius:4px;font-size:13px;font-weight:600;color:#555;">Impresi\u00F3n, 1 cara un color</button>'+
        '</div>'+
        '<div id="pm-qty-wrap" style="display:none;margin-bottom:16px;"></div>'+
        '<div id="pm-con" style="display:none;margin-bottom:16px;">'+
          '<div style="margin-bottom:14px;border:1px solid #e0e0e0;border-radius:6px;overflow:hidden;font-size:12px;">'+
            '<div style="background:#111;color:#fff;padding:8px 12px;font-weight:700;text-transform:uppercase;letter-spacing:1px;font-size:11px;">Especificaciones t\u00E9cnicas - Requerimiento obligatorio</div>'+
            '<table style="width:100%;border-collapse:collapse;">'+
              '<tr style="border-bottom:1px solid #eee;">'+
                '<td style="padding:7px 10px;font-weight:700;color:#111;background:#fafafa;width:38%;vertical-align:top;font-size:11px;text-transform:uppercase;letter-spacing:0.5px;">Formato de archivo</td>'+
                '<td style="padding:7px 10px;color:#444;font-size:12px;">Vectorial (AI, PDF, EPS). No se aceptan capturas de pantalla ni fotos de baja resoluci\u00F3n o generadas con IA.</td>'+
              '</tr>'+
              '<tr style="border-bottom:1px solid #eee;">'+
                '<td style="padding:7px 10px;font-weight:700;color:#111;background:#fafafa;font-size:11px;text-transform:uppercase;letter-spacing:0.5px;">Textos</td>'+
                '<td style="padding:7px 10px;color:#444;font-size:12px;">Todo texto debe estar convertido a <strong>curvas / contornos</strong> para evitar errores de fuente.</td>'+
              '</tr>'+
              '<tr style="border-bottom:1px solid #eee;">'+
                '<td style="padding:7px 10px;font-weight:700;color:#111;background:#fafafa;font-size:11px;text-transform:uppercase;letter-spacing:0.5px;">\u00C1rea de impresi\u00F3n</td>'+
                '<td style="padding:7px 10px;color:#444;font-size:12px;"><strong>'+areaDeImpresion+'</strong></td>'+
              '</tr>'+
              '<tr style="border-bottom:1px solid #eee;">'+
                '<td style="padding:7px 10px;font-weight:700;color:#111;background:#fafafa;font-size:11px;text-transform:uppercase;letter-spacing:0.5px;">Definici\u00F3n de trazo</td>'+
                '<td style="padding:7px 10px;color:#444;font-size:12px;">Grosor m\u00EDnimo de l\u00EDnea: <strong>0.5 pt</strong>. Detalles m\u00E1s finos pueden no revelarse en la malla.</td>'+
              '</tr>'+
              '<tr style="border-bottom:1px solid #eee;">'+
                '<td style="padding:7px 10px;font-weight:700;color:#111;background:#fafafa;font-size:11px;text-transform:uppercase;letter-spacing:0.5px;">Colores (tintas)</td>'+
                '<td style="padding:7px 10px;color:#444;font-size:12px;">Definir en <strong>Pantone Solid Coated</strong> o indicar color est\u00E1ndar (Negro, Blanco, Rojo, etc.).</td>'+
              '</tr>'+
              '<tr>'+
                '<td style="padding:7px 10px;font-weight:700;color:#111;background:#fafafa;font-size:11px;text-transform:uppercase;letter-spacing:0.5px;">Posicionado</td>'+
                '<td style="padding:7px 10px;color:#444;font-size:12px;">Centrado est\u00E1ndar.</td>'+
              '</tr>'+
            '</table>'+
          '</div>'+
          '<div style="padding:16px;border:2px dashed #ccc;border-radius:6px;background:#fafafa;">'+
            '<p style="font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:#111;margin:0 0 6px;">Subir dise\u00F1o para impresi\u00F3n *</p>'+
            '<p style="font-size:12px;color:#888;margin:0 0 12px;">AI, PDF, EPS - M\u00E1x. 10MB</p>'+
            '<label style="display:inline-flex;align-items:center;gap:6px;padding:9px 18px;background:#111;color:#fff;cursor:pointer;border-radius:4px;font-size:13px;font-weight:600;">'+
              '<input type="file" id="pm-file" accept=".png,.jpg,.jpeg,.pdf,.ai,.eps" style="display:none;">'+
              '[adjunto] Seleccionar archivo'+
            '</label>'+
            '<span id="pm-fname" style="display:block;margin-top:8px;font-size:13px;color:#555;"></span>'+
            '<input type="hidden" name="properties[Dise\u00F1o]" id="pm-ref" value="">'+
            '<div id="pm-status" style="margin-top:8px;font-size:13px;"></div>'+
          '</div>'+
        '</div>';
      var upDiv=document.createElement('div');
      upDiv.id='pm-unit-price';
      upDiv.style.cssText='font-size:16px;font-weight:600;color:#111;margin-top:0;margin-bottom:12px;';
      if(sa)sa.parentNode.insertBefore(upDiv,sa);
      else pf.appendChild(upDiv);
      if(sa)sa.parentNode.insertBefore(wrap,sa.nextSibling);
      else pf.appendChild(wrap);

      var qtyWrap=document.getElementById('pm-qty-wrap');

      // Always hide the native variant selector - we replace it with custom buttons
      if(vs)vs.style.setProperty('display','none','important');

      var prodScript=Array.from(document.querySelectorAll('script[type="application/json"]')).find(function(s){return s.id&&s.id.indexOf('ProductJson-')===0;});
      if(prodScript){
        setupProd(JSON.parse(prodScript.textContent));
      } else {
        fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(setupProd);
      }
      function setupProd(prod){

      // Separate "Por unidad" variant from bundle variants
      var unitVar=null;
      var bundleVars=[];
      prod.variants.forEach(function(v){
        if(v.title==='Por unidad'){unitVar=v;}
        else{bundleVars.push(v);}
      });

      // Build custom bundle selector buttons inside qtyWrap
      var customBtns=[];
      var curBundleVid=bundleVars.length>0?bundleVars[0].id:null;
      var currentMode='sin'; // track mode for reliable submit override

      // Label for the selector
      var selLabel=document.createElement('p');
      selLabel.textContent='Selecciona la cantidad:';
      selLabel.style.cssText='font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;color:#111;margin:0 0 8px;';
      qtyWrap.appendChild(selLabel);

      var btnGroup=document.createElement('div');
      btnGroup.style.cssText='display:flex;flex-wrap:wrap;gap:6px;';
      qtyWrap.appendChild(btnGroup);

      function selectBundleBtn(btn,v){
        customBtns.forEach(function(b){
          b.style.borderColor='#ddd';b.style.background='#fff';b.style.color='#555';
        });
        btn.style.borderColor='#111';btn.style.background='#111';btn.style.color='#fff';
        curBundleVid=v.id;
        setVariantId(v.id);
        // Also try to update native radio for Shopify theme JS compatibility
        if(vs){
          Array.from(vs.querySelectorAll('input[type="radio"]')).forEach(function(r){
            if(r.value.trim().toLowerCase()===v.title.trim().toLowerCase()){
              r.checked=true;
              r.dispatchEvent(new Event('change',{bubbles:true}));
            }
          });
        }
        setTimeout(updateUp,100);
      }

      bundleVars.forEach(function(v){
        var btn=document.createElement('button');
        btn.type='button';
        // Show clean quantity label: "200u", "300u" etc.
        var qty=v.title.replace(/\s*(unidades?|u\.?)\s*/i,'');
        var short=qty?qty+'u':v.title;
        btn.textContent=short;
        btn.title=v.title;
        btn.dataset.variantId=v.id;
        btn.style.cssText='padding:8px 14px;border:2px solid #ddd;background:#fff;cursor:pointer;border-radius:4px;font-size:13px;font-weight:600;color:#555;min-width:52px;text-align:center;';
        btn.addEventListener('click',function(){selectBundleBtn(btn,v);});
        btnGroup.appendChild(btn);
        customBtns.push(btn);
      });

      function fmtCLP(n){return '$'+n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.');}

      function setVariantId(vid){
        var hid=pf.querySelector('input[name="id"]');
        if(hid){hid.value=vid;}
      }

      function getCurVid(){
        var hid=pf.querySelector('input[name="id"]');
        if(hid&&hid.value){var v=parseInt(hid.value);if(!isNaN(v)&&v)return v;}
        return prod.variants[0]?prod.variants[0].id:null;
      }

      function showStepper(){
        if(qp)qp.style.removeProperty('display');
        else if(qi){qi.style.removeProperty('display');var prev=qi.previousElementSibling;var next=qi.nextElementSibling;if(prev)prev.style.removeProperty('display');if(next)next.style.removeProperty('display');}
      }
      function hideStepper(){
        if(qi)qi.value=1;
        if(qp)qp.style.setProperty('display','none','important');
        else if(qi){qi.style.setProperty('display','none','important');var prev=qi.previousElementSibling;var next=qi.nextElementSibling;if(prev)prev.style.setProperty('display','none','important');if(next)next.style.setProperty('display','none','important');}
      }

      function updateUp(){
        if(currentMode==='con'){
          // Use curBundleVid directly - more reliable than reading the DOM input (Shopify can overwrite it)
          var vid=curBundleVid;
          var totalCLP=0;
          if(vid){for(var i=0;i<prod.variants.length;i++){if(prod.variants[i].id===vid){totalCLP=Math.round(prod.variants[i].price/100);break;}}}
          if(!totalCLP&&bundleVars.length>0)totalCLP=Math.round(bundleVars[0].price/100);
          upDiv.innerHTML='Total: <b>'+fmtCLP(totalCLP)+'</b>';
        } else {
          var unitPrice=unitVar?Math.round(unitVar.price/100):(bundleVars.length>0?Math.round(bundleVars[0].price/bundleVars[0].title.match(/(\d+)/)[1]/100):0);
          upDiv.innerHTML='<b>'+fmtCLP(unitPrice)+'</b> / unidad';
        }
      }

      var bsin=document.getElementById('pm-btn-sin');
      var bcon=document.getElementById('pm-btn-con');
      var pmConDiv=document.getElementById('pm-con');
      function act(a,b){a.style.borderColor='#111';a.style.background='#111';a.style.color='#fff';b.style.borderColor='#ddd';b.style.background='#fff';b.style.color='#555';}

      // Cache Por unidad radio for fast lookup (search full form, not just vs)
      var unitRadio=null;
      if(unitVar){
        Array.from(pf.querySelectorAll('input[type="radio"]')).forEach(function(r){
          if(r.value.trim().toLowerCase()==='por unidad')unitRadio=r;
        });
      }

      bsin.addEventListener('click',function(){
        act(bsin,bcon);
        currentMode='sin';
        pmConDiv.style.display='none';
        qtyWrap.style.display='none';
        // Switch to Por unidad variant
        if(unitRadio){unitRadio.checked=true;unitRadio.dispatchEvent(new Event('change',{bubbles:true}));}
        if(unitVar){setVariantId(unitVar.id);}
        showStepper();
        updateUp();
      });

      bcon.addEventListener('click',function(){
        act(bcon,bsin);
        currentMode='con';
        pmConDiv.style.display='block';
        qtyWrap.style.display='block';
        hideStepper();
        // Select first custom button (activates first bundle variant + calls updateUp via setTimeout)
        if(customBtns.length>0){
          selectBundleBtn(customBtns[0],bundleVars[0]);
        } else {
          setTimeout(updateUp,100);
        }
      });

      document.getElementById('pm-file').addEventListener('change',function(e){
        var file=e.target.files[0];
        if(!file)return;
        if(file.size>10485760){document.getElementById('pm-status').innerHTML='<span style="color:#c00;">[!] Archivo muy grande. M\u00E1x. 10MB.</span>';return;}
        document.getElementById('pm-fname').textContent=file.name;
        document.getElementById('pm-status').innerHTML='<span style="color:#888;">[...] Subiendo dise\u00F1o...</span>';
        document.getElementById('pm-ref').value='';
        var fd=new FormData();fd.append('file',file);fd.append('filename',file.name);fd.append('product',window.location.pathname);
        fetch('https://rodarevalo.app.n8n.cloud/webhook/allbags-upload-design',{method:'POST',body:fd})
          .then(function(r){return r.json();})
          .then(function(d){if(d.success){document.getElementById('pm-ref').value=d.fileId;document.getElementById('pm-status').innerHTML='<span style="color:#2a7a2a;">[ok] Dise\u00F1o listo. Ref: '+d.fileId+'</span>';}else{throw new Error();}})
          .catch(function(){document.getElementById('pm-status').innerHTML='<span style="color:#c00;">[x] Error al subir. Intenta de nuevo.</span>';});
      });

      function forceCorrectVariant(){
        // Always enforce correct variant ID before any add-to-cart action
        if(currentMode!=='con'&&unitVar){setVariantId(unitVar.id);}
        else if(currentMode==='con'&&curBundleVid){setVariantId(curBundleVid);}
      }
      function blockIfNoFile(e){
        if(currentMode==='con'&&!document.getElementById('pm-ref').value){
          e.preventDefault();e.stopImmediatePropagation();
          document.getElementById('pm-status').innerHTML='<span style="color:#c00;">[!] Debes subir tu dise\u00F1o para continuar.</span>';
          document.getElementById('pm-con').scrollIntoView({behavior:'smooth',block:'center'});
        }
      }
      // Force correct variant on both submit AND click (AJAX themes skip submit event)
      pf.addEventListener('submit',forceCorrectVariant,true);
      pf.addEventListener('submit',blockIfNoFile,true);
      var addBtn=pf.querySelector('button[name="add"],button[type="submit"]');
      if(addBtn){
        addBtn.addEventListener('click',forceCorrectVariant,true);
        addBtn.addEventListener('click',blockIfNoFile,true);
      }

      // Activar modo Sin impresi\u00F3n por defecto
      bsin.click();
      } // end setupProd
    }
    function tryRun(){if(document.querySelector('form.product-form')){run();}else{setTimeout(tryRun,150);}}
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',tryRun);}else{tryRun();}
  }
  function applyPortafolio(){
    function hide(el){el.style.setProperty('display','none','important');}
    function run(){
      var sels=['.product-form__quantity-submit','.js-btn-wishlist','.js-btn-compare','.product-single__information.product-block','.product-block.salepoint','.fake-view.product-block','.product-block.product__text.subtop','.product-block.product-freeship','.product-block.product-single__meta-list','.product-single__meta .accordion'];
      sels.forEach(function(sel){document.querySelectorAll(sel).forEach(hide);});
      document.querySelectorAll('.product-block').forEach(function(b){if(b.className.trim()==='product-block')hide(b);});
      document.querySelectorAll('iframe[src*="pifyapp"]').forEach(function(ifr){if(!ifr.closest('form.product-form')){if(ifr.parentElement)hide(ifr.parentElement);}});
      var productForm=document.querySelector('form.product-form');
      var formInBuyArea=productForm?productForm.querySelector('iframe[src*="pifyapp"]'):null;
      if(!formInBuyArea&&productForm){
        var wrap=document.createElement('div');wrap.style.cssText='margin:16px 0;padding:0;';
        var lbl=document.createElement('p');lbl.textContent='Solicita tu cotizaci\u00F3n personalizada';lbl.style.cssText='font-size:14px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:#111;margin-bottom:16px;';
        var ifr=document.createElement('iframe');ifr.src='https://form-builder-en.pifyapp.com/form/s/29285';ifr.style.cssText='width:100%;height:540px;border:none;display:block;';ifr.setAttribute('frameborder','0');
        wrap.appendChild(lbl);wrap.appendChild(ifr);productForm.appendChild(wrap);
      }
    }
    function tryRun(){if(document.querySelector('form.product-form')){run();}else{setTimeout(tryRun,150);}}
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',tryRun);}else{tryRun();}
  }
})();
